import './helper-text.css';
export default {
  "helperText": "pf-v5-c-helper-text",
  "helperTextItem": "pf-v5-c-helper-text__item",
  "helperTextItemIcon": "pf-v5-c-helper-text__item-icon",
  "helperTextItemText": "pf-v5-c-helper-text__item-text",
  "modifiers": {
    "hidden": "pf-m-hidden",
    "indeterminate": "pf-m-indeterminate",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "error": "pf-m-error",
    "dynamic": "pf-m-dynamic"
  },
  "themeDark": "pf-v5-theme-dark"
};